import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { User } from '@app/ecsomag/user/models';

type AvatarStyle = 'full' | 'compact';

@Component({
	selector: 'gls-profile-user',
	templateUrl: 'user.component.html',
	styleUrls: ['user.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileUserComponent {
	@Input() user!: User;

	@HostBinding('class')
	@Input()
	style: AvatarStyle = 'full';

	public get initials() {
		return this.user.name
			.split(' ', 3)
			.map(n => n[0])
			.join('');
	}
}
